<template>
  <div>
    <div class="map-component" ref="googleMap"></div>
    <section id="map">
        <div id="map" ref="map" style="width:100%;height:400px;"></div>
    </section>
    <!-- <template v-if="Boolean(this.google) && Boolean(this.map)">
      <slot
        :google="google"
        :map="map"
      />
    </template> -->
  </div>
</template>

<script>
// import GoogleMapsApiLoader from 'google-maps-api-loader'

export default {
  name: 'MapComponent',
  props: {
    mapConfig: Object,
    apiKey: String,
  },
  data() {
    return {
      map: null
    }
  },

  mounted() {
    this.map = new window.google.maps.Map(this.$refs['map'], {
      center: { lat: 49.662337, lng: 19.174312 },
      zoom: 15
    })
  }
    // new window.google.maps.Marker({
    //   center: { lat: 49.662337, lng: 19.174312 },
    //   map: this.map
    // })
  // }
  // data() {
  //   return {
  //     google: null,
  //     map: null
  //   }
  // },
  //
  // async mounted() {
  //   const googleMapApi = await GoogleMapsApiLoader({
  //     apiKey: this.apiKey
  //   })
  //   this.google = googleMapApi
  //   this.initializeMap()
  // },
  //
  // methods: {
  //   initializeMap() {
  //     const mapContainer = this.$refs.googleMap
  //     this.map = new this.google.maps.Map(
  //       mapContainer, this.mapConfig
  //     )
  //   }
  // }
}

</script>
<style lang="sass">
  @import 'src/assets/stylesheets/style.sass'
</style>
